module.exports = __webpack_public_path__ + "static/media/personalized-icon.dbe8e289.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/personalized-icon.png
// module id = 94
// module chunks = 0